<template lang="pug">
#base-header
    .view-container
        .base-container
            .base-title-container
                h1.base__title
                    i.voltar.mdi.mdi-arrow-left-thick(
                        v-if='voltarPara',
                        @click='irParaRota(voltarPara)'
                    )
                    | {{ titulo }}
                .base__breadcrumb(v-if='breadcrumb')
                    el-breadcrumb(separator='.')
                        el-breadcrumb-item(
                            v-for='(sub, index) in breadcrumb',
                            :key='index'
                        )
                            span.link-breadcrumb(@click='irParaRota(sub.rota)')
                                | {{ sub.nome }}
            div.buttons-header
                el-tooltip(v-if="tooltip", placement='bottom')
                    div(slot="content", style="max-width: 200px;text-align: justify;") {{ tooltip }}
                    .base-button-container
                        slot(name='direita')
                        BaseButton.base-button-container__btn(
                            type='primary',
                            :icon='icon',
                            v-if='exibeBotao',
                            :disabled='desabilitaBotao',
                            :loading='loading',
                            @click='emit()'
                        )
                            | {{ btnTexto }}
                .base-button-container(v-else)
                    slot(name='direita')
                    BaseButton.base-button-container__btn(
                        type='primary',
                        :icon='icon',
                        v-if='exibeBotao',
                        :disabled='desabilitaBotao',
                        :loading='loading',
                        @click='emit()'
                    )
                        | {{ btnTexto }}
                .base-button-container(v-if="exibeBotaoSecundario")
                    slot(name='direita')
                    el-dropdown
                        BaseButton.base-button-container__btn(
                            type='primary',
                            :icon='iconBotaoSecundario',
                            :loading='loading'
                        )
                            | {{ btnTextoAcoes }}
                        el-dropdown-menu(slot="dropdown")
                            el-dropdown-item(
                                v-for='acao in acoes',
                                @click.native='realizarAcao(acao)'
                            ) {{ acao.titulo }}
</template>

<script>
// IMPORTANTE !! Utilize a classe .view-container-base-header para complementar o uso desse componente.
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'BaseHeaderPreAnaliseCredito',
    components: {
        BaseButton
    },
    emits: ['btnHeaderClicado'],
    props: {
        titulo: {
            type: String,
            default: () => ''
        },
        voltarPara: {
            type: [Object, Boolean, String],
            default: () => null
        },
        breadcrumb: {
            type: Array,
            default: () => []
        },
        acoes: {
            type: Array,
            default: () => []
        },
        btnTexto: {
            type: String,
            default: () => ''
        },
        btnTextoAcoes: {
            type: String,
            default: () => ''
        },
        icon: {
            type: String,
            default: () => ''
        },
        iconBotaoSecundario: {
            type: String,
            default: () => ''
        },
        exibeBotao: {
            type: Boolean,
            default: false
        },
        desabilitaBotao: {
            type: Boolean,
            default: false
        },
        tooltip: {
            type: String,
            default: () => null
        },
        loading: {
            type: Boolean,
            default: false
        },
        exibeBotaoSecundario: {
            type: Boolean,
            default: false
        },
        rotaHome: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        irParaRota(rota) {
            if (!rota) return;
            if (this.rotaHome) {
                this.$router.push({ name: 'Home' });
            }
            if (this.rotaHome === false && typeof rota === 'boolean' && rota) {
                this.$router.go(-1);
            }
        },
        emit() {
            this.$emit('btnHeaderClicado');
        },
        realizarAcao(acao) {
            this.$emit('realizarAcao', acao.emit);
        }
    }
};
</script>

<style lang="scss">
#base-header {
    background: var(--white);
    box-shadow: 0 1px 3px 0 var(--block-shadow);
    .base-container {
        width: 100%;
        min-height: 87px;
        background: var(--white);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .base__title {
            display: flex;
            align-items: center;
            .voltar {
                cursor: pointer;
                font-size: 27px;
                color: #303133;
            }
            .voltar:hover {
                color: var(--secondary);
            }
        }
        .base-title-container {
            display: flex;
            flex-direction: column;
            .base__title {
                font-weight: 600;
            }
            .base__breadcrumb {
                margin-top: 8px;
                span.link-breadcrumb {
                    color: #1989fa;
                    text-decoration: underline;
                    cursor: pointer;
                }
                span.link-breadcrumb:hover {
                    color: var(--secondary);
                }
            }
        }
    }
    .button-outline {
        border-color: var(--secondary-two) !important;
        color: var(--white) !important;
        background: var(--secondary-two) !important;
    }
    .base-button-container__btn {
        span {
            margin-left: 5px;
        }
    }
    .buttons-header {
        width: fit-content;
        display: flex;
        gap: 2%;
    }
}
</style>
